<div class="modal-header">
  <h5 class="modal-title">{{ 'common.providers' | translate }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 2rem !important;" [class.opacity-60]="loading">
  <div class="form-row align-items-end">
    <div class="form-group col-12">
      <label for="type">{{ 'company.transaction.filters.type' | translate }}</label>
      <select id="type" class="form-control icon-arrow-rtl" [formControl]="form.get('type')">
        <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
      </select>
    </div>

    <div class="form-group col-8">
      <label for="name">{{ 'common.new-provider' | translate }}</label>
      <input
        id="name"
        class="form-control"
        [formControl]="form.get('name')"
        (keyup.enter)="addProvider()"
      />
    </div>
    <div class="form-group col-4">
      <button style="color: white !important;" class="btn btn-primary btn-block mt-4" (click)="addProvider()" [disabled]="loading">
        {{ 'common.add' | translate }}
      </button>
    </div>
  </div>

  <hr />

  <div *ngIf="!list?.length && !loading" class="text-muted">
    {{ 'common.still-no-providers' | translate }}
  </div>

  <ul class="list-group providers-list">
    <li
      class="list-group-item d-flex justify-content-between align-items-center"
      *ngFor="let p of list"
    >
      <span>
        {{ p.name }}
      </span>

      <div class="policy-actions">
        <button
          tabindex="-1"
          mat-button
          color="warn"
          class="policy-action-btn"
          (click)="deleteProvider(p)"
          [disabled]="loading || p.integrated"
        >
          <p style="margin: 0;">{{ 'common.delete' | translate }}</p>
        </button>
      </div>
    </li>
  </ul>

</div>

<div class="modal-footer custom-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">{{ "common.close" | translate }}</button>
</div>
